// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__YOFTk","noResults":"styles_noResults__UiYOG","list":"styles_list__GF4QD","container":"styles_container__gKkh6","clearIcon":"styles_clearIcon__4VXC0"};